import { useEffect } from "react";

const DeleteUserDialog = ({ user, onClose, onConfirm }) => {

    useEffect(() => {
        
        document.body.style.overflow = "hidden";
        
        return () => {
            document.body.style.overflow = "auto";
        };

    }, []);

    if (!user) return null;
    
    return (
        <div className="fixed w-screen h-screen top-0 !mt-0 left-0 inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-[10000]">

            <div className="bg-white w-full max-w-sm rounded-xl shadow-xl p-6">

                <h2 className="text-lg flex items-center gap-1 font-semibold text-red-600 mb-3">
                   
                    حذف کاربر
                    <span className="text-primary text-base">
                        ({user?.firstName + ' ' + user?.lastName})
                    </span>

                </h2>

                <p className="text-sm text-gray-600 mb-6">
                    آیا مطمئن هستید می‌خواهید این کاربر را حذف کنید؟  
                    <br />
                    <span className="font-semibold text-gray-800">{user.name || user.email}</span>
                </p>

                <div className="flex justify-between">
                    
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-100 rounded-lg text-sm hover:bg-gray-200"
                    >
                        انصراف
                    </button>

                    <button
                        onClick={() => {
                            onConfirm();
                            onClose();
                        }}
                        className="px-4 py-2 bg-red-600 text-white rounded-lg text-sm hover:bg-red-700"
                    >
                        حذف
                    </button>

                </div>

            </div>

        </div>
    );
};

export default DeleteUserDialog;
